import { makeRequestAction } from './index';

export const fetchLenderContacts = makeRequestAction('FETCH_LENDER_CONTACTS', {
  onSuccess(params, response) {
    return {
      response: {
        entities: {
          lenderContacts: response,
        },
      },
    };
  },
});

export const addNewContact = makeRequestAction('ADD_NEW_CONTACT', {
  onSuccess(params, response) {
    return { response };
  },
});

export const editContact = makeRequestAction('EDIT_CONTACT', {
  onSuccess(params, response) {
    return { response };
  },
});
